import React from "react";
import Tile from "../Tile";

function FloatingTile({ floatingTile, clientX, clientY, boardScale, rackScale, overBoard, floatingTileClickHandler }) {
    if (!floatingTile) return null;

    

    return (
        <div
            style={{
                position: "fixed",
                top: clientY,
                left: clientX,
                border: "dashed 1px red",
                xcursor: "none"
            }}
            onClick={floatingTileClickHandler}
        >
            <Tile
                letter={floatingTile.tile.letter}
                points={floatingTile.tile.value}
                scale={overBoard ? boardScale : rackScale}
                xbottom={-((overBoard ? boardScale * 2 : rackScale) / 2)}
                bottom={-37.5}
                xposition={-(overBoard ? boardScale * 2 : rackScale) / 2}
                position={-37.5}
                style={{
                    position: "absolute",
                    boxShadow: `${boardScale / 5}px ${boardScale / 5}px ${boardScale / 25}px rgba(0, 0, 0, 0.25)`
                }}
            />
        </div>
    );
}

export default React.memo(FloatingTile);
